// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbarResponsive--BKakb {
  height: 100%;
  align-items: center;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  position: sticky;
  top: 0px;
  z-index: 101;
  background: #FFF;
  box-shadow: 0 2px 8px -2px rgba(0, 21, 80, 0.15);
}
.navbarResponsive--BKakb .trialBanner--iFNLG {
  grid-column: 1/-1;
  grid-row: 2/2;
  z-index: 0;
  background: #0A855C;
  text-align: center;
  padding: 1rem;
  color: #FFF;
}
.navbarResponsive--BKakb .logo--hqPZD {
  grid-column-start: 2;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 1;
  display: inline-flex;
  z-index: 2;
}
.navbarResponsive--BKakb .buttons--Jysal {
  grid-column-start: 24;
  grid-column-end: 26;
  grid-row-start: 1;
  grid-row-end: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
}
.navbarResponsive--BKakb .buttonsDesktop--J2vTS {
  grid-column-start: 20;
  grid-column-end: 26;
  grid-row-start: 1;
  grid-row-end: 1;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  height: 74px;
}
.slideMenu--fCwPi {
  height: 100vh;
  width: 300px;
  background: #FFF;
  top: 121px;
  right: 0;
  position: fixed;
  z-index: 2;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  animation-name: slideIn--HSLKS;
  animation-duration: 300ms;
  animation-timing-function: ease-in-out;
  padding: 1.5rem;
}
.slideMenu--fCwPi.oneLineNavbar--pNbtY {
  top: 112px;
}
.slideMenu--fCwPi .buttons--Jysal {
  display: flex;
  flex-direction: column;
  margin-top: 10rem;
}
.slideMenu--fCwPi .buttons--Jysal > * {
  width: 100%;
  height: 44px;
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #2D3748;
  position: relative;
  z-index: 1;
}
.slideMenu--fCwPi .buttons--Jysal > *:hover:after {
  content: '';
  position: absolute;
  width: calc(100% + 3rem);
  height: 100%;
  left: -1.5rem;
  top: 0;
  background: #D9E3FF;
  z-index: -1;
}
.slideMenu--fCwPi .expiryDate--gFwXc {
  width: 100%;
  text-align: right;
  height: 60px;
  color: #2D3748;
  border-bottom: 1px solid #2D3748;
  margin-bottom: 0.5rem;
}
.platformGuide--b3wQQ {
  display: flex;
}
@keyframes slideIn--HSLKS {
  from {
    right: -80%;
  }
  to {
    right: 0;
  }
}
@media (min-width: 320px) {
  .navbarResponsive--BKakb {
    z-index: 50;
  }
  .navbarResponsive--BKakb .trialBanner--iFNLG {
    grid-row: 3/3;
  }
  .logo--hqPZD {
    padding-top: 0.5rem;
  }
}
@media (min-width: 1148px) {
  .navbarResponsive--BKakb {
    height: 100%;
  }
  .navbarResponsive--BKakb .trialBanner--iFNLG {
    grid-row: 2/2;
  }
  .navbarResponsive--BKakb .logo--hqPZD {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/navbar.module.less"],"names":[],"mappings":"AAIE;EAAA,YAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,4DAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA;AALA;AADF;EASI,iBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAFJ;AAMI;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,eAAA;EACA,oBAAA;EACA;AAFA;AAMA;EAAA,qBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,yBAAA;EACA;AADA;AAKA;EAAA,qBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,aAAA;EAAA,YAAA;EAAA,yBAAA;EACA;AADA;AAKJ;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,4CAAA;EACA,8BAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;AAPF;AASE;EACE,UAAA;AAPJ;AARA;EAmBI,aAAA;EACA,sBAAA;EACA,iBAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AARN;AAWQ;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,mBAAA;EACA,WAAA;AATV;AAnCA;EAmDI,WAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;EACA,qBAAA;AAbJ;AAiBA;EACE,aAAA;AAfF;AAkBA;EACE;IACE,WAAA;EAhBF;EAkBA;IACE,QAAA;EAhBF;AACF;AAmBA;EACE;IACE,WAAA;EAjBF;EAgBA;IAII,aAAA;EAjBJ;EAsBE;IAAA;EAAA;AAlBJ;AAsBA;EACE;IACE,YAAA;EApBF;EAmBA;IAII,aAAA;EApBJ;EAgBA;IAQI,UAAA;EArBJ;AACF","sourcesContent":["@import '~@boclips-ui/styles/src/breakpoints';\n@import '~@boclips-ui/styles/src/colors';\n\n.navbarResponsive {\n  @apply items-center h-full bg-white;\n  position: sticky;\n  top: 0px;\n  z-index: 101;\n  background: @white;\n  box-shadow: 0 2px 8px -2px rgba(0, 21, 80, 0.15);\n\n  .trialBanner {\n    grid-column: 1/-1;\n    grid-row: 2/2;\n    z-index: 0;\n    background: @success;\n    text-align: center;\n    padding: 1rem;\n    color: @white;\n  }\n\n  .logo {\n    @apply col-start-2 col-end-5 row-start-1 row-end-1;\n    display: inline-flex;\n    z-index: 2;\n  }\n\n  .buttons {\n    @apply col-start-24 col-end-26 row-start-1 row-end-1 flex justify-end items-center;\n    height: 60px;\n  }\n\n  .buttonsDesktop {\n    @apply col-start-20 col-end-26 row-start-1 row-end-1 flex h-full justify-end;\n    height: 74px;\n  }\n}\n\n.slideMenu {\n  height: 100vh;\n  width: 300px;\n  background: @white;\n  top: 121px;\n  right: 0;\n  position: fixed;\n  z-index: 2;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n  animation-name: slideIn;\n  animation-duration: 300ms;\n  animation-timing-function: ease-in-out;\n  padding: 1.5rem;\n\n  &.oneLineNavbar {\n    top: 112px;\n  }\n\n  .buttons {\n    display: flex;\n    flex-direction: column;\n    margin-top: 10rem;\n\n    & > * {\n      width: 100%;\n      height: 44px;\n      font-size: 1rem;\n      font-weight: 400;\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      color: @gray-800;\n      position: relative;\n      z-index: 1;\n\n      &:hover {\n        &:after {\n          content: '';\n          position: absolute;\n          width: calc(100% + 3rem);\n          height: 100%;\n          left: -1.5rem;\n          top: 0;\n          background: @blue-400;\n          z-index: -1;\n        }\n      }\n    }\n  }\n\n  .expiryDate {\n    width: 100%;\n    text-align: right;\n    height: 60px;\n    color: @gray-800;\n    border-bottom: 1px solid @gray-800;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.platformGuide {\n  display: flex;\n}\n\n@keyframes slideIn {\n  from {\n    right: -80%;\n  }\n  to {\n    right: 0;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .navbarResponsive {\n    z-index: 50;\n\n    .trialBanner {\n      grid-row: 3/3;\n    }\n  }\n\n  .logo {\n    @apply pt-2;\n  }\n}\n\n@media (min-width: @screen-lg) {\n  .navbarResponsive {\n    height: 100%;\n\n    .trialBanner {\n      grid-row: 2/2;\n    }\n\n    .logo {\n      padding: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbarResponsive": `navbarResponsive--BKakb`,
	"trialBanner": `trialBanner--iFNLG`,
	"logo": `logo--hqPZD`,
	"buttons": `buttons--Jysal`,
	"buttonsDesktop": `buttonsDesktop--J2vTS`,
	"slideMenu": `slideMenu--fCwPi`,
	"slideIn": `slideIn--HSLKS`,
	"oneLineNavbar": `oneLineNavbar--pNbtY`,
	"expiryDate": `expiryDate--gFwXc`,
	"platformGuide": `platformGuide--b3wQQ`
};
export default ___CSS_LOADER_EXPORT___;
